/**
 * @generated SignedSource<<92851622b6ae0997e8a3a95ef369220c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StrategyAccountFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BowPoolXykAccountFragment" | "PerpsPoolAccountFragment" | "StakingPoolPageAccountFragment" | "ThorchainPoolAccountFragment">;
  readonly " $fragmentType": "StrategyAccountFragment";
};
export type StrategyAccountFragment$key = {
  readonly " $data"?: StrategyAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StrategyAccountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StrategyAccountFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BowPoolXykAccountFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PerpsPoolAccountFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ThorchainPoolAccountFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StakingPoolPageAccountFragment"
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "45fde9f950523660565c1042ff587f91";

export default node;
